import getMappings from './getMappingsFromMappingCards';

export default (mappingCards: any[]) => {
  const mappings = getMappings(mappingCards);

  const selectedDestinations = mappings.reduce((acc: any[], mapping: any) => {
    if (mapping.destination) {
      acc.push(mapping.destination);
    }
    return acc;
  }, []);

  return selectedDestinations;
};
